export const init = () => {
  // TRACKER 'PRODUCT-MEDIA'
  const sep = AnalyticsConstants.concatenator;
  const fwk = CUBE.Analytics;
  const utils = fwk.utils.productpage;
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.product.media);

  const getProductLabel = () => {
    const productName = tc_vars.product_label_displayed;
    const productNature = '%PRODUCT_NATURE%'; // TODO : tc_vars.product_nature;
    const modelId = utils.getSelectedModelId();
    return productName + sep + modelId;
  };
  // MoreInformations
  const moreInformations = new AnalyticsClickEvent('moreInformations', tracker.defaultEvent());
  moreInformations.domElement = '.product-informations > a';
  moreInformations.options.action = 'MoreInformations';
  moreInformations.getLabel = getProductLabel;
  tracker.addEvent(moreInformations);
  // MoreViews
  const moreViews = new AnalyticsClickEvent('moreViews', tracker.defaultEvent());
  moreViews.domElement = '.product-picture .product-picture__slider a';
  moreViews.options.action = 'MoreViews';
  moreViews.getLabel = getProductLabel;
  tracker.addEvent(moreViews);
  // tabContent
  const tabContent = new AnalyticsClickEvent('tabContent', tracker.defaultEvent());
  tabContent.domContainer = 'nav#sticky-product-nav';
  tabContent.domElement = 'a';
  tabContent.getAction = $element => {
    const indexTab = $element.closest('nav').find('a').index($element) + 1;
    const labelTab = $element.attr('id').replace('_Tab', '');
    return `Tab-${indexTab}-${labelTab}`;
  };
  tabContent.getLabel = getProductLabel;
  //tabContent.getValue = function(){ return productPrice; };
  tracker.addEvent(tabContent);
  // Slick Pictures
  const productPicture = new AnalyticsSlickEvent('productPicture', tracker.defaultEvent());
  productPicture.domContainer = '.slick-pp-pictures-img';
  productPicture.trackArrows({
    getAction($element) {
      if ($element.hasClass(AnalyticsConstants.slick.selectorCssArrowNext.replace('.', ''))) return 'Pictures-NextPicture';
      if ($element.hasClass(AnalyticsConstants.slick.selectorCssArrowPrev.replace('.', ''))) return 'Pictures-PreviousPicture';
      return '';
    },
    getLabel: getProductLabel
  });
  tracker.addEvent(productPicture);
  // Swiper Pictures
  const swipeProductPicture = new AnalyticsClickEvent('swipeProductPicture', tracker.defaultEvent());
  swipeProductPicture.domElement = '.swiper-container div[class^="swiper-button"]';
  swipeProductPicture.getAction = $element => {
    let action = 'Pictures-';
    if ($element.hasClass('swiper-button-prev'))
      action += 'PreviousPicture';
    else
      action += 'NextPicture';
    return action;
  };
  swipeProductPicture.getLabel = getProductLabel;
  tracker.addEvent(swipeProductPicture);
  // -------------
  // GALLERY EVENTS
  // GALLERY - Arrows
  const galleryArrows = new AnalyticsClickEvent('galleryArrows', tracker.defaultEvent());
  galleryArrows.domContainer = '#myGallery';
  galleryArrows.domElement = 'div.gallery-tool-previous, div.gallery-tool-next';
  galleryArrows.getAction = $element => {
    if ($element.hasClass('gallery-tool-next')) return 'Zoom-ArrowNextPicture';
    if ($element.hasClass('gallery-tool-previous')) return 'Zoom-ArrowPreviousPicture';
    return '';
  };
  galleryArrows.getLabel = getProductLabel;
  tracker.addEvent(galleryArrows);
  // GALLERY - Category
  const galleryCategory = new AnalyticsClickEvent('galleryCategory', tracker.defaultEvent());
  galleryCategory.domContainer = '#myGallery';
  galleryCategory.domElement = '.gallery-panel-category a';
  galleryCategory.getAction = $element => {
    const value = $element.text().trim();
    return `Zoom-ClickCategory-${value}`;
  };
  galleryCategory.getLabel = getProductLabel;
  tracker.addEvent(galleryCategory);
  // GALLERY - Picture list
  const galleryPictureList = new AnalyticsClickEvent('galleryPictureList', tracker.defaultEvent());
  galleryPictureList.domContainer = '#myGallery .gallery-panel-media ul.picture, #myGallery .gallery-panel-media ul.video';
  galleryPictureList.domElement = 'li';
  galleryPictureList.getAction = $element => {
    const indexElement = $element.closest('ul').find('li').index($element) + 1;
    const typeList = $element.closest('ul').hasClass('picture') ? 'Picture' : 'Video';
    return `Zoom-Click${typeList}-${indexElement}`;
  };
  galleryPictureList.getLabel = getProductLabel;
  tracker.addEvent(galleryPictureList);
  // GALLERY - Zoom (scroll) in big picture
  const galleryBigZoom = new AnalyticsTriggerEvent('galleryBigZoom', tracker.defaultEvent());
  galleryBigZoom.trigger = 'mousewheel';
  galleryBigZoom.domContainer = '#myGallery';
  galleryBigZoom.domElement = '.gallery-panel-viewer';
  galleryBigZoom.getAction = () => {
    const indexElement = $('.gallery-panel-media ul.picture li').index($('.gallery-panel-media ul.picture li.active')) + 1;
    return `Big-Zoom-${indexElement}`;
  };
  galleryBigZoom.getLabel = getProductLabel;
  tracker.addEvent(galleryBigZoom);
  // GALLERY - Close button
  const galleryClose = new AnalyticsClickEvent('galleryClose', tracker.defaultEvent());
  galleryClose.domContainer = '#myGallery';
  galleryClose.domElement = '.gallery-tool-close';
  galleryClose.options.action = 'Zoom-Close';
  galleryClose.getLabel = getProductLabel;
  tracker.addEvent(galleryClose);
  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/product/media-tracker.js